const AboutCalpecoin = () => {
    return (
        <section id="que-es-calpecoin" className="App-section">
        <h2>¿Qué es Calpecoin?</h2>
        <p>
          Calpecoin es una red de cadena de bloques, una blockchain creada a
          partir de un fork de Dash, creada para extender el uso y desarrollo
          de tecnología descentralizada en Calpe.
        </p>
        <p>
          La red permite a los usuarios enviar y recibir valor digital escaso
          usando la moneda interna de la red (también llamada Calpecoin y
          abreviada como CALP)
        </p>
        <p>
          La iniciativa está enfocada generar valor social y tecnológico para
          el pueblo, no necesariamente económico. El objetivo es que los
          ciudadanos de Calpe tengan un entorno más amigable y local en el que
          familiarizarse con este tipo de entornos descentralizados y
          construir sus ideas.
        </p>
        <h3>Fork de Dash</h3>
        <p>
          Dash, también conocida como Darkcoin y Xcoin, es una blockchain
          pública. Funciona con un algoritmo de consenso que combina minería
          Proof of work con Proof of Service, un sistema de votaciones de
          nodos maestros (masternodes) precursor del Proof of Stake.
        </p>
        <p>
          El código de Dash se ha usado como base para desarrollar Calpecoin.
          Elegimos el algoritmo de consenso de Dash, combinando Proof of Work
          X11 y Proof of Service porque queríamos que los usuarios pudieran
          experimentar la minería pero no queríamos exponer la red a ataques
          del 51% por tener una potencia total demasiado baja.
        </p>
        <p>
          El sistema híbrido impide que un atacante pueda escribir datos
          arbitrarios en la blockchain incluso si posee el 51% o más de la
          potencia de minería.
        </p>
        <h3>Neutralidad de la red</h3>
        <p>
          Calpecoin NO es una blockchain pública. Podría decirse que es
          híbrida. Los datos son públicos y el acceso a la red como usuario
          también lo es, pero para montar un nodo hay que cumplir una serie de
          requisitos.
        </p>
      </section>
    )
}

export default AboutCalpecoin